import { render } from "./ConformModal.vue?vue&type=template&id=210d2f74&scoped=true"
import script from "./ConformModal.vue?vue&type=script&lang=js"
export * from "./ConformModal.vue?vue&type=script&lang=js"

import "./ConformModal.vue?vue&type=style&index=0&id=210d2f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210d2f74"]])

export default __exports__